import { PAGE } from '@/app/definitions'

export const nonAuthNavMap = [
  {
    name: PAGE.ACCOUNT.LOGIN,
    title: 'Log in',
    url: '/login',
  },
  {
    name: PAGE.ACCOUNT.SIGNUP,
    title: 'Sign up',
    url: '/signup',
  },
]

export const authNavMap = [
  {
    id: 'contacts',
    name: PAGE.CONTACTS.INDEX,
    title: 'Contacts',
    url: '/contacts',
    icon: 'perm_contact_calendar',
    pageGroup: PAGE.CONTACTS,
  },
  {
    id: 'campaigns',
    name: PAGE.CAMPAIGNS.INDEX,
    title: 'Campaigns',
    url: '/campaigns',
    icon: 'dns',
    pageGroup: PAGE.CAMPAIGNS,
  },
  {
    id: 'content',
    name: PAGE.CONTENT.INDEX,
    title: 'Content',
    url: '/content',
    icon: 'content_paste',
    pageGroup: PAGE.CONTENT,
  },
  {
    id: 'conversations',
    name: PAGE.CONVERSATIONS.INDEX,
    title: 'Conversations',
    url: '/conversations',
    icon: 'message',
    pageGroup: PAGE.CONVERSATIONS,
  },
  {
    id: 'logs',
    name: PAGE.LOGS.INDEX,
    title: 'Logs',
    url: '/logs',
    icon: 'summarize',
    pageGroup: PAGE.LOGS,
  },
  {
    id: 'phoneNumbers',
    name: PAGE.PHONENUMBERS.INDEX,
    title: 'Phone Numbers',
    url: '/phonenumbers',
    icon: 'phone',
    pageGroup: PAGE.PHONENUMBERS,
  },
  {
    id: 'reports',
    name: PAGE.REPORTS.INDEX,
    title: 'Reports',
    url: '/reports',
    icon: 'bar_chart',
    pageGroup: PAGE.REPORTS,
  },
]

export const mobileAuthNavMap = [
  {
    id: 'dashboard',
    name: PAGE.DASHBOARD.INDEX,
    title: 'Dashboard',
    url: '/',
    icon: 'home',
    pageGroup: PAGE.DASHBOARD,
  },
  ...authNavMap,
]

export const mobileAccountNavMap = [
  {
    id: 'profile',
    title: 'Account',
    url: '/account',
    icon: 'work',
    pageGroup: PAGE.ACCOUNT.PROFILE,
    displayWithoutOrg: true,
  },
  {
    id: 'billing',
    title: 'Billing',
    url: '/billing',
    icon: 'payment',
    pageGroup: PAGE.ACCOUNT.BILLING,
    displayWithoutOrg: false,
  },
  {
    id: 'organization',
    title: 'Organization',
    url: '/organization',
    icon: 'supervisor_account',
    pageGroup: PAGE.ACCOUNT.ORGANIZATION,
    displayWithoutOrg: false,
  },
]

export const accountNavMap = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    url: '/',
    icon: 'home',
    pageGroup: PAGE.DASHBOARD,
    displayWithoutOrg: true,
  },
  ...mobileAccountNavMap,
]

export const catiAccountNavMap = [
  {
    id: 'profile',
    title: 'Account',
    url: '/account',
    icon: 'work',
    pageGroup: PAGE.ACCOUNT.PROFILE,
    displayWithoutOrg: true,
  },
]
